import { useState } from 'react';
import { useSelector } from 'react-redux';

import DownloadIcon from '@mui/icons-material/Download';
import { Button, CircularProgress, Tooltip } from '@mui/material';

import { getDashboardOrdersExport } from '../../../../actions/admin/dashboard';
import { msg } from '../../../../actions/swal_msg';
import {
    downloadDashboardOrdersCsv,
    formatDashboardDateKey
} from '../../../../helpers/admin/dashboard/dashboardExportHelper';

const DashboardOrdersExportButton = ({
    reportType,
    range,
    segment,
    filename,
    label = 'Descargar pedidos (.csv)',
    size = 'small'
}) => {
    const canExport = useSelector(
        state => Boolean(state.user.loggedUser?.privileges?.orders)
    );
    const [loading, setLoading] = useState(false);

    if (!canExport)
        return null;

    const download = async () => {
        if (loading || !range?.startDate || !range?.endDate)
            return;

        setLoading(true);
        try {
            const result = await getDashboardOrdersExport({
                reportType,
                dateFrom: formatDashboardDateKey(range.startDate),
                dateTo: formatDashboardDateKey(range.endDate),
                ...(segment && { segment })
            });

            if (!result.status) {
                const forbidden = result.msg === 'forbidden';
                msg(
                    'error',
                    forbidden ? 'Acceso restringido' : 'No se pudo descargar',
                    forbidden
                        ? 'Necesitas el privilegio de pedidos para exportar estos datos.'
                        : 'Intenta nuevamente en unos momentos.'
                );
                return;
            }

            if (!result.rows?.length) {
                msg(
                    'info',
                    'Sin pedidos para exportar',
                    'El periodo seleccionado no contiene pedidos para este reporte.'
                );
                return;
            }

            downloadDashboardOrdersCsv(reportType, result.rows, filename);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Tooltip title={label}>
            <span>
                <Button
                    color="primary"
                    size={size}
                    disabled={loading}
                    onClick={download}
                    startIcon={loading
                        ? <CircularProgress size={16} color="inherit" />
                        : <DownloadIcon />}
                >
                    {loading ? 'Preparando…' : label}
                </Button>
            </span>
        </Tooltip>
    );
};

export default DashboardOrdersExportButton;
